import { useConfigurationQuery } from 'theSource/queries';
import { useCompanySettingsQuery } from 'theSource/queries/useCompanySettingsQuery';

export const useOliveAdvisorEnabled = (): boolean => {
  const { configuration } = useConfigurationQuery();
  const companySettingsQuery = useCompanySettingsQuery({
    enabled: Boolean(configuration?.apiHost),
  });

  if (!companySettingsQuery) {
    return false; // or handle the undefined case appropriately
  }

  const { companySettings } = companySettingsQuery;
  return companySettings?.data?.olive_advisor_license || false;
};
